import styled from '@emotion/styled';
import { Text, type TextProps } from '@mantine/core';

export const BooleanIndicator = styled('div')<{
  color: string;
}>(({ theme, color }) => ({
  width: 8,
  height: 8,
  borderRadius: theme.radius.xl,
  backgroundColor: color,
}));

export const OutputText = styled(Text)<TextProps>(({ theme }) => ({
  fontFamily: theme.fontFamilyMonospace,
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
}));
